import request from '@/config/axios'
export const getOrderPage = (params: any) => request.get({ url: '/rental/order/page', params })
export const completeOrder = (id: number) =>
  request.put({ url: '/rental/order/complete', params: { id } })
export const cancelOrder = (id: number) =>
  request.put({ url: '/rental/order/cancel', params: { id } })
export const refundRentOrder = (id: number) =>
  request.put({ url: '/rental/order/refund-rent', params: { id } })
export const setOverdueFee = (data: { id: number; overdueFee: number; overdueDays?: number }) =>
  request.put({ url: '/rental/order/overdue-fee', data })

export const getOrder = (id: number) => request.get({ url: '/rental/order/get', params: { id } })
